var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/report-detail.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-97497aee!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/report-detail.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ReportDetail.vue
// module id = 347
// module chunks = 1